var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShotVaccineRebrand = function SvgShotVaccineRebrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 29 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Shot-Vaccine-rebrand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M20.757 12.78h2.41c.68 0 1.23.55 1.23 1.232v1.858h-4.886v-1.858c0-.681.55-1.232 1.23-1.232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M8.596 28.038h-3.64v6.119h3.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M6.746 8.512a.61.61 0 0 1-.62-.62V.613c0-.344.268-.612.62-.612s.62.268.62.612v7.28c0 .353-.268.62-.62.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M4.956 7.893h3.64c.681 0 1.232.55 1.232 1.231v1.859H3.709V9.124c0-.68.551-1.23 1.232-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M11.618 11.534V27.41h-9.76V11.534c0-.681.551-1.232 1.232-1.232h7.28c.682.07 1.232.62 1.232 1.232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M8.597 11.534V27.41H1.859V11.534c0-.681.55-1.232 1.246-1.232h4.26c.68.07 1.232.62 1.232 1.232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F1F",
    d: "M11.618 19.51v6.73h-9.76v-6.73S2.47 21.37 5.5 21.37c1.101 0 2.126-.275 3.029-.826.963-.482 1.797-1.032 3.09-1.032"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M.076 26.18h13.4v.611a1.85 1.85 0 0 1-1.858 1.86h-9.76A1.85 1.85 0 0 1 0 26.79v-.611zM3.105 33.522h7.281c.68 0 1.232.55 1.232 1.232V36h-9.76v-1.246c0-.681.551-1.232 1.232-1.232"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M4.337 23.77a.606.606 0 0 1-.62.613H1.859V23.15h1.858c.352 0 .62.268.62.62M4.337 18.264c0 .352-.268.62-.62.62H1.859v-1.232h1.858c.352 0 .62.268.62.612M4.337 15.243a.606.606 0 0 1-.62.612H1.859v-1.232h1.858c.352 0 .62.268.62.62M28.122 23.564V34.77c0 .68-.55 1.231-1.231 1.231h-9.76a1.23 1.23 0 0 1-1.23-1.231V23.564c0-.612.282-1.231.68-1.713l1.645-1.644c.481-.482.68-1.094.68-1.714v-1.445h6.119v1.445c0 .62.268 1.232.68 1.714l1.645 1.644a2.25 2.25 0 0 1 .765 1.713"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M25.033 23.564V34.77c0 .68-.551 1.231-1.232 1.231h-6.73a1.23 1.23 0 0 1-1.232-1.231V23.564c0-.612.268-1.231.681-1.713l1.644-1.644c.482-.482.681-1.094.681-1.714v-1.445h3.029v1.445c0 .62.268 1.232.68 1.714L24.2 21.85c.62.42.833 1.032.833 1.713"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M18.363 15.243h7.281c.352 0 .62.268.62.62v1.23a.615.615 0 0 1-.62.613h-7.28a.614.614 0 0 1-.613-.612v-1.232c0-.351.268-.62.612-.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F1F",
    d: "M28.054 25.01H15.885v7.28h12.169z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF4EC",
    d: "M23.235 28.039h-.62v-.62a.615.615 0 0 0-.619-.612.615.615 0 0 0-.62.612v.62h-.619a.606.606 0 0 0-.62.611c0 .345.284.62.62.62h.62v.612c0 .351.283.62.62.62.336 0 .619-.284.619-.62v-.612h.62c.343 0 .619-.268.619-.62a.6.6 0 0 0-.62-.611"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Shot-Vaccine-rebrand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28.122v36H0z"
  })))));
};
export default SvgShotVaccineRebrand;